import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { List, PictureAsPdf } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Button,
    ButtonGroup,
    Grid,
    TextField,
} from '@mui/material';
import { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getMergedAuthorizedInsts } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';

function ReportAuthorityListFilterCard({
    title,
    setFilterData,
    handleResultList,
    generatePDFApi,
}) {
    const [state, setState] = useState({
        selectedInst: [],
    });
    const [loading, setLoading] = useState(false);
    const [lastFilter, setLastFilter] = useState(null);
    const [instList, setInstList] = useState([]);
    const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);
    const allReadAuthorizedInsts = useSelector(state => state.auth.allReadAuthorizedInsts);
    const mergedAuthorizedInsts = getMergedAuthorizedInsts(allAuthorizedInsts, allReadAuthorizedInsts);
    const isInstLocked = mergedAuthorizedInsts.length === 1;

    useEffect(() => {
        setInstList(mergedAuthorizedInsts);
        setState(prevState => {
            const nextSelected = isInstLocked ? [mergedAuthorizedInsts[0]] : mergedAuthorizedInsts;
            const isSame = nextSelected.length === prevState.selectedInst.length
                && nextSelected.every((inst, i) => inst === prevState.selectedInst[i]);
            return isSame ? prevState : { ...prevState, selectedInst: nextSelected };
        });
    }, [isInstLocked, allAuthorizedInsts, allReadAuthorizedInsts]);

    const isUnitSelected = state.selectedInst.length > 0;
    const hasDataToClear = isInstLocked
        ? false
        : state.selectedInst.length !== mergedAuthorizedInsts.length;

    const handleResultListClick = async () => {
        const filters = {
            instIds: state.selectedInst.map(inst => inst.id || inst),
        };

        setLoading(true);
        try {
            await handleResultList(filters);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleGeneratePDF = async () => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await generatePDFApi();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setState({
            selectedInst: isInstLocked ? [mergedAuthorizedInsts[0]] : mergedAuthorizedInsts,
        });
        setLastFilter(null);
        setFilterData([]);
    };

    return (
        <>
            <LoadingPopUp open={loading} />
            {!loading && (
                <JumboCardQuick title={title}>
                    <Grid container spacing={1} mb={1}>
                        <Grid item xs={3}>
                            <Autocomplete
                                multiple
                                size="small"
                                id="inst-autocomplete"
                                options={instList}
                                value={state.selectedInst}
                                onChange={(event, newValue) => {
                                    if (isInstLocked) return;
                                    if (newValue.length > 0) {
                                        setState(prevState => ({ ...prevState, selectedInst: newValue }));
                                    }
                                }}
                                disabled={isInstLocked}
                                getOptionLabel={(option) => option || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Kurum" variant="outlined" size="small" />
                                )}
                                disableCloseOnSelect
                            />
                        </Grid>

                        {/* İşlem Butonları */}
                        <Grid item xs={2}>
                            <ButtonGroup>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<List />}
                                    onClick={() => handleResultListClick()}
                                    disabled={!isUnitSelected}
                                >
                                    Listele
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<PictureAsPdf />}
                                    disabled={!lastFilter || !isUnitSelected}
                                    onClick={() => handleGeneratePDF()}
                                >
                                    PDF
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    color="success"
                                    startIcon={<DeleteIcon />}
                                    onClick={() => handleClear()}
                                    disabled={!hasDataToClear}
                                >
                                    TEMİZLE
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </JumboCardQuick>
            )}
        </>
    );
}

export default ReportAuthorityListFilterCard; 